<script lang="ts" setup>
import SiteFooter from '@/components/SiteFooter.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import SkrButton from '@/components/button/SkrButton.vue'

const route = useRoute()

const layoutMeta = computed(() => {
  return {
    login: true,
    signup: false,
    showLogo: true,
    ...route.meta.unauthenticated,
  } satisfies CustomPageMeta['unauthenticated']
})

const display = useDisplay()
const { t } = useI18n()

const info = computed(() => {
  return layoutMeta.value.login
    ? {
        hintText: t('signup.already_have_account'),
        buttonText: t('global.login'),
        toRoute: { name: 'login' },
      }
    : {
        hintText: t('login.subtitle'),
        buttonText: t('global.signup'),
        toRoute: { name: 'signup' },
      }
})
</script>

<template>
  <v-main>
    <slot name="header">
      <site-header>
        <template v-if="!layoutMeta.showLogo" #left>
          <div />
        </template>
        <template v-if="layoutMeta.login || layoutMeta.signup" #right>
          <div v-if="display.smAndUp" class="d-flex align-center">
            <span class="mr-4">{{ info.hintText }}</span>
            <skr-button type="secondary" size="lg" :to="info.toRoute">
              {{ info.buttonText }}
            </skr-button>
          </div>
          <skr-button v-else :to="{ name: 'login' }" type="secondary" size="lg" rounded>
            <v-icon size="medium">custom:padlock</v-icon>
          </skr-button>
        </template>
      </site-header>
    </slot>
    <div class="content">
      <slot />
    </div>
    <site-footer />
  </v-main>
</template>

<style lang="scss" scoped>
.content {
  height: 100%;
  max-width: calc(#{$site-width} + #{($base-width * 3 * 2)});
  margin: 0 auto;
}
</style>
